module.exports = __webpack_public_path__ + "img/default.fee9458c.png";